// Landing slug and utm_source sent with a popup sign-up. Both can be set per popup in the panel
// (wizardComponent fields landingSlug / utmSource); empty = the fixed values used before.
export interface PopupTracking {
    landingSlug?: string | null;
    utmSource?: string | null;
}

export const DEFAULT_UTM_SOURCE = 'popup_wizard';

export const popupLandingSlug = (selectedWizard?: string, tracking?: PopupTracking): string =>
    tracking?.landingSlug?.trim() || (selectedWizard === 'wizard2' ? 'nokhbegan-popup' : 'wizard');

// The page the visitor signed up from (no protocol). The visitor's own utm_source stays;
// otherwise the popup's is added.
export const popupReferrer = (tracking?: PopupTracking): string => {
    if (typeof window === 'undefined') return '';
    const { host, pathname, search } = window.location;
    const utm = tracking?.utmSource?.trim() || DEFAULT_UTM_SOURCE;
    const q = /[?&]utm_source=/.test(search)
        ? search
        : `${search}${search ? '&' : '?'}utm_source=${encodeURIComponent(utm)}`;
    return `${host}${pathname}${q}`;
};
